<template>
    <ClientOnly>
        <Carousel
            :value="portfolioItems"
            :num-visible="1"
            :num-scroll="1"
            circular
            :show-indicators="false"
            class="portfolio-carousel"
            @update:page="onPageChange"
        >
            <template #item="slotProps">
                <PortraitProfilePhoto :photo-url="slotProps.data.url" :alt="slotProps.data.title" :face-crop="slotProps.data.isProfilePhoto" />
            </template>
            <template #previcon>
                <VJoyIcon name="arrow-left" color="white" size="xsmall" />
            </template>
            <template #nexticon>
                <VJoyIcon name="arrow-right" color="white" size="xsmall" />
            </template>
        </Carousel>
        <template #fallback>
            <PortraitProfilePhoto :photo-url="photoUrl || '/anonymous'" face-crop />
        </template>
    </ClientOnly>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import Carousel from 'primevue/carousel';
    import {VJoyIcon} from '@maltjoy/core-vue';
    import PortraitProfilePhoto from './PortraitProfilePhoto.vue';
    import type {PortfolioItem} from '../types';

    interface ProfilePhotoProps {
        photoUrl?: string;
        portfolio: PortfolioItem[];
    }

    const props = defineProps<ProfilePhotoProps>();

    const emit = defineEmits<{
        'portfolio-clicked': [];
    }>();

    type PortfolioCarouselItem = PortfolioItem & {isProfilePhoto: boolean};

    const portfolioItems = computed<PortfolioCarouselItem[]>(() => [
        {
            title: '',
            url: props.photoUrl || '/anonymous',
            isProfilePhoto: true,
        },
        ...props.portfolio.map((item) => ({
            ...item,
            isProfilePhoto: false,
        })),
    ]);

    function onPageChange(newPage: number) {
        if (portfolioItems.value[newPage]?.isProfilePhoto === false) {
            emit('portfolio-clicked');
        }
    }
</script>

<style scoped lang="scss">
    .portfolio-carousel {
        :deep(.p-carousel-prev-button),
        :deep(.p-carousel-next-button) {
            position: absolute;
            z-index: 1;
            padding: 0;

            --p-button-icon-only-width: 40px;

            background: var(--joy-color-overlay);
            backdrop-filter: blur(2px);
        }

        :deep(.p-carousel-prev-button) {
            left: var(--joy-core-spacing-1);
        }

        :deep(.p-carousel-next-button) {
            right: var(--joy-core-spacing-1);
        }

        :deep(.p-carousel-viewport) {
            height: 100% !important;
        }
    }
</style>
